/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles((theme) => ({
    root: {
        width: 56,
        height: 32,
        padding: 0,
    },
    switchBase: {
        padding: 4,
        '&$checked': {
            color: '#fff',
            transform: 'translateX(24px)',
            '& + $track': {
                backgroundColor: theme.palette.action.activeBlue,
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.action.activeBlue,
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 32 / 2,
        backgroundColor: theme.palette.action.dimGrey,
        opacity: 1,
    },
    checked: {},
    focusVisible: {},
}));

const SwitchButton = (props) => {
    const classes = useStyles();
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
};

export default SwitchButton;
